import { Component } from "react"
import AvailableInCountry from "../index/AvailableInCountry"

export class CardsInfoContent extends Component {
  render = () => (
    <div className="container light">
      <div className="row">
        <div className="col-lg-6">
          <div className="main-cards__content text-lg-left text-center">
            <h2 className="title title__cards">Get a Debit Crypto card for Your everyday purchase</h2>
            <p className="main-cards__text">Use 7Gates debit card for online or offline shopping or to withdraw cash from the ATM!</p>
            <div className="main-cards__bottom">
              <a href="login" className="button button_bg_red main-cards__link">
                ORDER CARD
              </a>
              <AvailableInCountry />
            </div>
          </div>
        </div>
        <div className="col-lg-6 clearfix">
          <img
            src="/img/card-n-phone.png"
            alt="card-n-phone"
            className="img-fluid main-cards__picture float-lg-right"
            style={{ marginBottom: 60 }}
          />
        </div>
      </div>
    </div>
  )
}
